import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function RedSiren({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>RedSiren</title>
      <path
        d="M17.7557 13.3478C17.7557 12.9336 17.4199 12.5978 17.0057 12.5978C16.5915 12.5978 16.2557 12.9336 16.2557 13.3478H17.7557ZM8.0166 13.3478C8.0166 12.9336 7.68082 12.5978 7.2666 12.5978C6.85239 12.5978 6.5166 12.9336 6.5166 13.3478H8.0166ZM16.2557 13.3478V19.4348H17.7557V13.3478H16.2557ZM8.0166 19.4348V13.3478H6.5166V19.4348H8.0166ZM7.2666 13.3478C8.0166 13.3478 8.0166 13.3482 8.0166 13.3485C8.0166 13.3486 8.0166 13.3489 8.0166 13.3491C8.0166 13.3494 8.0166 13.3497 8.0166 13.3499C8.0166 13.3503 8.0166 13.3504 8.0166 13.3503C8.0166 13.3499 8.01661 13.3485 8.01665 13.346C8.01673 13.3409 8.01693 13.3315 8.01737 13.3181C8.01827 13.2913 8.02017 13.2485 8.02421 13.192C8.03229 13.0788 8.04883 12.9122 8.08248 12.7103C8.15038 12.3029 8.28479 11.7711 8.54612 11.2485C8.80598 10.7287 9.18399 10.2318 9.73697 9.86318C10.2853 9.49765 11.05 9.22827 12.1362 9.22827V7.72827C10.7875 7.72827 9.7262 8.06758 8.90492 8.6151C8.08834 9.15949 7.55331 9.87998 7.20448 10.5776C6.85711 11.2724 6.68717 11.958 6.60289 12.4637C6.56046 12.7183 6.53895 12.9321 6.52802 13.0852C6.52254 13.1618 6.51969 13.2237 6.51821 13.2682C6.51746 13.2904 6.51706 13.3084 6.51685 13.3218C6.51674 13.3285 6.51668 13.334 6.51664 13.3384C6.51663 13.3405 6.51662 13.3424 6.51661 13.344C6.51661 13.3448 6.5166 13.3455 6.5166 13.3461C6.5166 13.3465 6.5166 13.3469 6.5166 13.347C6.5166 13.3475 6.5166 13.3478 7.2666 13.3478ZM15.4405 20.25H12.1362V21.75H15.4405V20.25ZM12.1362 20.25H8.83182V21.75H12.1362V20.25ZM12.1362 9.22827C13.2223 9.22827 13.9871 9.49765 14.5354 9.86318C15.0883 10.2318 15.4664 10.7287 15.7262 11.2485C15.9875 11.7711 16.122 12.3029 16.1899 12.7103C16.2235 12.9122 16.24 13.0788 16.2481 13.192C16.2522 13.2485 16.2541 13.2913 16.255 13.3181C16.2554 13.3315 16.2556 13.3409 16.2557 13.346C16.2557 13.3485 16.2557 13.3499 16.2557 13.3503C16.2557 13.3504 16.2557 13.3503 16.2557 13.3499C16.2557 13.3497 16.2557 13.3494 16.2557 13.3491C16.2557 13.3489 16.2557 13.3486 16.2557 13.3485C16.2557 13.3482 16.2557 13.3478 17.0057 13.3478C17.7557 13.3478 17.7557 13.3475 17.7557 13.347C17.7557 13.3469 17.7557 13.3465 17.7557 13.3461C17.7557 13.3455 17.7557 13.3448 17.7557 13.344C17.7557 13.3424 17.7557 13.3405 17.7557 13.3384C17.7557 13.334 17.7556 13.3285 17.7555 13.3218C17.7553 13.3084 17.7549 13.2904 17.7541 13.2682C17.7526 13.2237 17.7498 13.1618 17.7443 13.0852C17.7334 12.9321 17.7119 12.7183 17.6694 12.4637C17.5852 11.958 17.4152 11.2724 17.0679 10.5776C16.719 9.87998 16.184 9.15949 15.3674 8.6151C14.5461 8.06758 13.4848 7.72827 12.1362 7.72827V9.22827ZM6.5166 19.4348C6.5166 20.7135 7.55316 21.75 8.83182 21.75V20.25C8.38159 20.25 8.0166 19.885 8.0166 19.4348H6.5166ZM16.2557 19.4348C16.2557 19.885 15.8907 20.25 15.4405 20.25V21.75C16.7192 21.75 17.7557 20.7135 17.7557 19.4348H16.2557ZM16.2557 13.3478C16.2557 13.3478 17.0057 13.3478 17.7557 13.3478C17.7557 13.3478 17.7557 13.3478 17.0057 13.3478C16.2557 13.3478 16.2557 13.3478 16.2557 13.3478C17.0057 13.3478 17.7557 13.3478 17.7557 13.3478H16.2557ZM6.5166 13.3478C6.5166 13.3478 7.2666 13.3478 8.0166 13.3478C8.0166 13.3478 8.0166 13.3478 7.2666 13.3478C6.5166 13.3478 6.5166 13.3478 6.5166 13.3478C7.2666 13.3478 8.0166 13.3478 8.0166 13.3478H6.5166Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M7.30469 18.6521H16.696"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 11C12.913 10.8696 14.7391 11.2348 14.7391 13.7391"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.9619 3V5.34783"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18.2607 5.3479L16.6742 7.07853"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.3916 10.8262L19.0438 10.8262"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.34766 10.8262L2.99983 10.8262"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.73926 5.3479L7.39942 7.00806"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
